module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAABI0lEQVR4AWOgC/h/5EhU9d4jF57/Dw8Hko5pm4EiDMYzsSAIAKoGqoBrALKBeiAqGPWa+PQSmfXaUDT8////79+/QBKo4T8MqDtFcRjks+tWhifEsuvV8Rnn8puFQTUA1UGRnBycLWXvI2Bvr2IbWlzjoGwfWl5pqeII0wBxNMJJK1b09u/lMA5XcfFNTLFprkh0CLfUcg3RcY2D2TB9ul/hDriG6q79QP0CJsXFTY7+3S3JzU1GJW3i9q7MuhVQDVgDRNbOVyogVLlmXefqXJHMZR6xblb+Xvg08BqV+WYEhLSFti3QN8pIknX1ZNOvwqeB0XCytFW6e756/ixpnQBbToM8BqNpCA1YEZdRlYRljE2chahZGpdhLVAEoYFYNCgBAEPatkTyUZ+0AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/PN.png
// module id = 1243
// module chunks = 0